export default "__VITE_ASSET__DOenjjIm__"